<template>
  <v-container id="event">
    <v-breadcrumbs
      v-if="isSala"
      :items="breadCrumbs"
      divider=">"
    ></v-breadcrumbs>
    <app-city-header :payload="payload"> </app-city-header>
    <v-col class="diagnosticoSelo mt-9">
      <div class="titulo">STATUS DO CLIENTE OCULTO</div>
      <div class="tituloStatus">{{ situacaoMunicipio }}</div>
      <div>
        <v-row>
          <v-col>
            <v-btn
              color="azulclarosc"
              class="ml-3"
              style="color: #fff"
              @click="openDiagnosticoSelo"
            >
              <template>
                {{
                  situacaoMunicipio == "Cliente oculto não iniciado"
                    ? "Iniciar"
                    : situacaoMunicipio == "Cliente oculto em preenchimento"
                    ? "Continuar"
                    : "Visualizar"
                }}
                Cliente Oculto
              </template>
            </v-btn>
          </v-col>
          <v-col
            v-if="
              situacaoMunicipio == 'Cliente oculto enviado' &&
              (isFullAdmin ||
                (config.reabrirCliente && groupsConfig.reabrirCliente))
            "
          >
            <v-btn
              color="success"
              class="ml-3"
              style="color: #fff"
              @click="reabrirCliente"
            >
              Reabrir Cliente Oculto
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-col>

    <v-row v-if="situacaoMunicipio == 'Cliente oculto enviado'">
      <v-col class="download">
        <v-btn
          color="laranja"
          class="ml-3"
          @click="downloadPdf"
          style="color: #fff"
        >
          Download Cliente Oculto
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { seloClienteOcultoPerguntasAPI } from "../API/seloClienteOcultoPerguntasAPI";
import { seloClienteOcultoRespostaAPI } from "../API/seloClienteOcultoRespostaAPI";

import { AppCityHeader } from "@/modules/city";
import moment from "moment";
import { cityAPI } from "@/modules/city";

export default {
  components: {
    AppCityHeader,
  },
  data() {
    return {
      situacaoMunicipio: null,
      payload: {
        municipioId: this.$route.params.id,
      },
      municipioId: this.$route.params.id,
      municipio: null,
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      breadCrumbs: [
        {
          text: "Selecionar a Sala",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Sala",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
      ],
    };
  },

  methods: {
    ...mapActions(["setLoading"]),
    openDiagnosticoSelo() {
      this.$router.push("/cidade/" + this.municipioId + "/cliente-oculto");
    },
    situacaoClienteOculto() {
      this.setLoading(true);
      seloClienteOcultoPerguntasAPI
        .getSituacaoDiagnostico(this.$route.params.id)
        .then(({ data: situacao }) => {
          this.situacaoMunicipio = situacao[0].situacao;
          this.getCity();
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter o status do cliente oculto");
        });
    },
    reabrirCliente() {
      this.setLoading(true);
      seloClienteOcultoRespostaAPI
        .reabrirCliente(this.$route.params.id)
        .then((_) => {
          location.reload();
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao reabrir cliente oculto");
        });
    },
    downloadPdf() {
      this.setLoading(true);
      seloClienteOcultoRespostaAPI
        .downloadPdf(this.municipioId)
        .then((resp) => {
          let blob = new Blob([resp.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = `Cliente Oculto - ${this.municipio.nome} - ${
            this.municipio.uf
          } - ${moment().format("DD_MM_YYYY_HH_mm")}.pdf`;
          link.click();
          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter PDF");
        });
    },
    getCity() {
      cityAPI
        .get(this.$route.params.id)
        .then((resp) => {
          this.municipio = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter município");
        });
    },
  },

  beforeMount() {
    if (this.isParceiro) {
      this.breadCrumbs = [
        {
          text: "Selecionar o Parceiro",
          disabled: false,
          to: "/",
          exact: true,
        },
        {
          text: "Parceiro",
          disabled: false,
          to: `/cidade/${this.$route.params.id}`,
          exact: true,
        },
        {
          text: "Status Cliente Oculto",
          disabled: true,
          to: `/cidade/${this.$route.params.id}/cliente-oculto/info`,
          exact: true,
        },
      ];
    }
  },

  async mounted() {
    this.situacaoClienteOculto();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "isSala", "isParceiro"]),
  },
};
</script>
<style scoped>
.tituloStatus {
  font-size: 40px;
  font-weight: bold;
}
.diagnosticoSelo {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  /* padding: 3rem; */
  row-gap: 3rem;
}

.download {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
